import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './config'

import {BrowserRouter, HashRouter, Route, Routes} from 'react-router-dom';
import {Layout} from "./components/Layout";
import Table_articles from "./components/Table_articles";
import SingleArticle from "./components/SingleArticle";
import Home from "./components/Home";
import Table_blogers from "./components/Table_blogers";
import SingleBlogger from "./components/SingleBlogger";
import NotFound from "./components/NotFound";

const root = ReactDOM.createRoot(document.getElementById('root'));

// ReactDOM.createRoot(document.getElementById('root')).render(
//     <React.StrictMode>
//         <BrowserRouter>
//             <App />
//         </BrowserRouter>
//     </React.StrictMode>
// );

//hydrateRoot(document.getElementById('root'), <App />);

root.render(
  <React.StrictMode>
      <HashRouter>
          <Routes basename="/">
              <Route path="" element={<Layout />}>
                  <Route index  element={<Home />} />
                  <Route path="/news" element={<Table_articles />} />
                  <Route path="/news/:slug" element={<SingleArticle />} />
                  <Route path="/bloggers" element={<Table_blogers />} />
                  <Route path="/bloggers/:slug" element={<SingleBlogger />} />
                  <Route path="/wiki" element={<Table_articles />} />
                  <Route path="/guides" element={<Table_articles />} />
                  <Route path="/polls" element={<Table_articles />} />
                  <Route path="/wiki/:slug" element={<SingleArticle />} />
                  <Route path="/guides/:slug" element={<SingleArticle />} />
                  <Route path="/polls/:slug" element={<SingleArticle />} />
                  <Route path="*" element={<NotFound />} />
              </Route>
          </Routes>
      </HashRouter>
  </React.StrictMode>
);
// root.render(
//   <React.StrictMode>
//       <BrowserRouter>
//           <App />
//       </BrowserRouter>
//   </React.StrictMode>
// );

// const router = BrowserRouter([
//     {
//         // it renders this element
//         element: <App />,
//
//         // when the URL matches this segment
//         path: "bloggers/:bloggerID",
//
//         // with this data loaded before rendering
//         loader: async ({ request, params }) => {
//             return fetch(
//                 // `/fake/api/teams/${params.teamId}.json`,
//                 `/?method=bloggers_feed&slag=${params.bloggerID}`,
//                 { signal: request.signal }
//             );
//         },
//
//         // performing this mutation when data is submitted to it
//         action: async ({ request }) => {
//             return updateFakeTeam(await request.formData());
//         },
//
//         // and renders this element in case something went wrong
//         //errorElement: <ErrorBoundary />,
//     },
// ]);

// const updateFakeTeam = (request) => {
//     root.render(
//         <React.StrictMode>
//             <Bloggers />
//         </React.StrictMode>
//     );
//     // return(
//     //     <div>{request.body}</div>
//     // );
// }
//
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
